import { useMutation } from "@tanstack/react-query";

import { signConsentDocuments } from "~/patients/api/consentDocuments";

export const useSignConsentDocuments = () => {
  return useMutation({
    mutationFn: signConsentDocuments,
  });
};
